export default {
    props: {
        cap: Object,
        capColor: {
            type: String,
            default: undefined,
            kComposite: 'cap.color'
        },
        capSize: {
            type: Number,
            default: undefined,
            kComposite: 'cap.size'
        },
        color: {
            type: String,
            default: undefined,
            kComposite: 'color'
        },
        value: {
            type: Number,
            default: undefined,
            kComposite: 'value'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-gauges-vue-wrapper/src/KendoRadialGauge/PointerProps.js